// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YYKvKGjr{font-size:1.7em;margin-top:1rem}.XtWMJmDK{margin-top:0;font-size:1.3rem}.HuQFgkqi{background-color:var(--theme-background-secondary)}`, "",{"version":3,"sources":["webpack://./src/page-components/intent/generate-utterances.module.scss"],"names":[],"mappings":"AAAA,UACE,eAAA,CACA,eAAA,CAGF,UACE,YAAA,CACA,gBAAA,CAGF,UACE,kDAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `YYKvKGjr`,
	"description": `XtWMJmDK`,
	"utteranceContainer": `HuQFgkqi`
};
export default ___CSS_LOADER_EXPORT___;
